<template>
  <div>
    <div class="container">
      <app-more title="阅读室建设"></app-more>
      <div class="">
        <div class="flex">
          <div class="echart">
            <div ref="myChartRef" id="myChart"></div>
            <div class="ft">
              <h4>热门借阅书籍</h4>
              <h6>点击图书类型查看细节</h6>
            </div>
          </div>
          <div class="datas" ref="datas">
            <img src="../../assets/img/ebg.png" alt="" />
            <div class="abs">
              <div class="fc" v-if="res && res.read1 && res.read2 && res.read3">
                <div class="c">
                  <div class="img"><img src="../../assets/img/e1.png" /></div>
                  <div class="content">
                    <h3>
                      <count-to
                        v-if="an"
                        :startVal="0"
                        :endVal="res.read1.number"
                        :duration="1000"
                      ></count-to
                      >间
                    </h3>
                    <h6>{{ res.read1.f }}</h6>
                  </div>
                </div>

                <div class="c">
                  <div class="img"><img src="../../assets/img/e2.png" /></div>
                  <div class="content">
                    <h3>
                      <count-to
                        v-if="an"
                        :startVal="0"
                        :endVal="res.read2.number"
                        :duration="1000"
                      ></count-to
                      >个
                    </h3>
                    <h6>{{ res.read2.f }}</h6>
                  </div>
                </div>

                <div class="c">
                  <div class="img"><img src="../../assets/img/e3.png" /></div>
                  <div class="content">
                    <h3>
                      <count-to
                        v-if="an"
                        :startVal="0"
                        :endVal="res.read3.number"
                        :duration="1000"
                      ></count-to
                      >本
                    </h3>
                    <h6>{{ res.read3.f }}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="kktm" v-if="res && res.readSwiper">
      <div class="container">
        <div class="title" v-if="res && res.readSwiper">
          {{ res.readSwiper.title }}
        </div>
        <p class="cent" v-if="res && res.readSwiper">
          {{ res.readSwiper.d }}
        </p>
        <swiper
          class="kktmSwiper"
          ref="kktmSwiper"
          :options="swiperOptions"
          @ready="handleSwiperReadied($event)"
        >
          <swiper-slide v-for="(v, k) of res.readSwiper.banner" :key="k">
            <img src="../../assets/img/kkbg.png" alt="" />
            <div class="s-abs">
              <div class="st">
                {{ v.c }}
              </div>
              <div class="sb">
                <div>{{ v.u }}</div>
                <p>{{ v.z }}</p>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import echarts from "echarts";
import more from "../public/more.vue";
import countTo from "vue-count-to";
import { log } from "util";
export default {
  components: {
    "app-more": more,
    countTo,
    Swiper,
    SwiperSlide,
    directive,
  },
  name: "banner",
  props: ["res"],
  data() {
    return {
      an: false,
      swiper: "",
      options: "",
      swiperOptions: {
        watchSlidesProgress: true,
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        loopedSlides: 3,
        autoplay: false,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    };
  },
  created() {},

  methods: {
    handleSwiperReadied(swiper) {
      this.swiper = swiper;
    },
    SwiperReady() {
      if (this.bannerSwiper) {
        this.bannerSwiper.destroy();
      }
      this.$nextTick(() => {
        this.bannerSwiper = new Swiper(
          "#kktm > .swiper-container",
          this.bannerSwiperOption
        );
      });
    },
    echart(option1, option2) {
      var option;
      if (document.body.clientWidth < 992) {
        option = option2;
      } else {
        option = option1;
      }
      // this.options = option
      //初始化方法
      var e = echarts.init(document.getElementById("myChart"));
      e.setOption(option);
    },
    scrollListener() {
      //   if (
      //     !this.an &&
      //     this.$refs.datas.getBoundingClientRect().top <
      //       document.body.clientHeight + 100 - this.$refs.datas.offsetHeight &&
      //     this.$refs.datas.getBoundingClientRect().top >
      //       -this.$refs.datas.offsetHeight
      //   ) {
      //        console.log('true')
      //     this.an = true;
      //   }
      //   if (
      //     this.an &&
      //     !(
      //       this.$refs.datas.getBoundingClientRect().top <
      //         document.body.clientHeight - this.$refs.datas.offsetHeight &&
      //       this.$refs.datas.getBoundingClientRect().top >
      //         -this.$refs.datas.offsetHeight
      //     )
      //   ) {
      //       console.log('false')
      //     this.an = false;
      //   }
      if (
        !(
          this.$refs.datas.getBoundingClientRect().top -
            this.$refs.datas.offsetHeight >
            200 ==
          this.$refs.datas.getBoundingClientRect().top >
            200 - this.$refs.datas.offsetHeight
        )
      ) {
        if (!this.an) {
          this.an = true;
        }
      } else {
        if (this.an) {
          this.an = false;
        }
      }

      // this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
      //    console.log( this.$refs.datas.getBoundingClientRect().top - this.$refs.datas.offsetHeight > 200 == this.$refs.datas.getBoundingClientRect().top  >  100 - this.$refs.datas.offsetHeight,this.$refs.datas.getBoundingClientRect().top - this.$refs.datas.offsetHeight > 200, this.$refs.datas.getBoundingClientRect().top  >  100 - this.$refs.datas.offsetHeight )
    },
  },
  watch: {
    res(){
       try {
        var p1 = JSON.parse(this.$props.res.code1);
        var p2 = JSON.parse(this.$props.res.code2);
        this.echart(p1, p2);
      } catch (e) {
        console.log("error");
      }
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.SwiperReady();
      })();
    };

    // setTimeout(() => {
    //   try {
    //     var p1 = JSON.parse(this.$props.res.code1);
    //     var p2 = JSON.parse(this.$props.res.code2);
    //     this.echart(p1, p2);
    //   } catch (e) {
    //     console.log("error");
    //   }
    // }, 1500);

    this.$nextTick(() => {
      setTimeout(() => {
        this.SwiperReady();
      }, 1000);
    });
    this.scrollListener();
    window.addEventListener("scroll", this.scrollListener);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.swiper-container {
  img {
    width: 100%;
  }
}
.ft {
  padding-bottom: 30px;
}
#kktm {
  background: url("../../assets/img/kktmbg.png") top center no-repeat;
  text-align: center;
  padding: 120px 5px 70px;
  .kktmSwiper {
    .swiper-slide {
      max-width: 540px;
      width: 33%;
      min-width: 340px;
      //   background: url("../../assets/img/kkbg.png") no-repeat center center;
      //   background-size: 100%;

      .s-abs {
        box-sizing: border-box;
        position: absolute;
        width: 100%;
        height: 100%;
        padding: 25% 8% 12%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        top: 0;
        left: 0;
      }
      .st {
        text-align: justify;
        width: 100%;
        font-size: 18px;
        font-weight: 500;
        color: #000000;
      }
      .sb {
        width: 100%;
        text-align: left;
        div {
          font-size: 24px;
          font-weight: 500;
          color: #eb565a;
        }
        p {
          font-size: 20px;
          font-weight: 500;
          color: #000000;
        }
        // text-align: justify;
      }
    }
  }
  .swiper-pagination {
    width: 100%;
    position: relative;
    bottom: 0;
    margin-top: 60px;
    /deep/ .swiper-pagination-bullet {
      margin: 0 13px;
      border: 3px solid #d5d5d5 !important;
      background-color: #d5d5d5 !important;
      width: 17px;
      height: 17px;
      opacity: 1;
    }
    /deep/ .swiper-pagination-bullet-active {
      border: 3px solid #fff !important;
      background-color: #fff !important;
    }
  }

  .title {
    font-size: 24px;
    font-weight: 500;
    color: #000000;
    width: 60%;
    margin: 0 auto 0;
  }
  .cent {
    text-align: justify;
    font-size: 16px;
    color: #000000;
    line-height: 28px;
    width: 60%;
    margin: 38px auto 60px;
  }
}
#myChart {
  width: 100%;
  height: 600px;
}
.flex {
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;
  align-items: flex-end;
  .echart {
    flex: 0 0 600px;
    text-align: center;
    margin: 0 auto;
    h4 {
      margin: 20px 0;
      font-size: 26px;
      font-weight: 500;
      color: #000000;
      line-height: 26px;
    }
    h6 {
      font-size: 14px;
      color: #000000;
      line-height: 35px;
    }
  }
  .datas {
    flex: 0 0 650px;
    max-width: 650px;
    position: relative;
    margin: 0 auto;
    overflow: hidden;
    img {
      max-width: 100%;
    }
    .abs {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .fc {
        margin: 0 auto;
        height: 100%;
        display: flex;
        box-sizing: border-box;
        padding: 10% 0 10%;
        flex-direction: column;
        justify-content: space-around;
      }
      .c {
        // width: 80%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .img {
          width: 60px;
          height: 60px;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          overflow: hidden;
          img {
            max-width: 100%;
            max-height: 100%;
          }
        }
        .content {
          margin-left: 20px;
          h3 {
            font-size: 28px;
            font-weight: 500;
            color: #000000;
            line-height: 60px;
          }
          h6 {
            white-space: nowrap;
            font-size: 16px;
            font-weight: 500;
            color: #000000;
          }
        }
      }
    }
  }
}
@media (max-width: 1600px) {
  #myChart {
    width: 100%;
    height: 450px;
  }
  .flex {
    .echart {
      flex: 0 0 450px;
    }
    .datas {
      flex: 0 0 450px;
    }
  }

  #kktm .kktmSwiper .swiper-slide .st {
    font-size: 14px;
  }
  #kktm .kktmSwiper .swiper-slide .sb {
    font-size: 16px;
  }
}

@media (max-width: 992px) {
  #myChart {
    width: 100%;
    height: 400px;
  }
  .flex {
    flex-flow: wrap;
    justify-content: space-between;
    align-items: center;
    .echart {
      flex: 0 0 400px;
    }
    .datas {
      overflow: hidden;
      flex: 0 0 300px;
      .abs {
        .fc {
          margin: 0 auto;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
        }
        flex: auto;
        .c {
          margin: 0px 0;
          .img {
            margin-left: 0;
            width: 30px;
            height: 30px;
          }
          .content {
            h3 {
              font-size: 20px;
              line-height: 1.5;
            }
            h6 {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
  #kktm {
    .title {
      width: 100%;
      margin: auto;
      font-size: 24px;
    }
    .cent {
      margin: 20px auto;
      width: 100%;
    }
    .kktmSwiper {
      .swiper-slide {
        height: auto;
      }
    }
  }
}

@media (max-width: 765px) {
  .flex {
    display: block;
    .echart {
      flex: auto;
    }
    .datas {
      overflow: hidden;
      flex: auto;
    }
  }
  #kktm {
    .title {
      width: 100%;
      margin: auto;
      font-size: 24px;
    }
    .cent {
      margin: 20px auto;
      width: 100%;
      font-size: 14px;
      line-height: 24px;
    }
    .kktmSwiper {
      .swiper-slide {
        width: 100%;
        height: auto;
        .st {
          font-size: 14px;
        }
        .sb {
          div {
            font-size: 18px;
          }
          p {
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>
